import React from 'react';

import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import {Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';

import './dialog.scss';
import dialogMapper from './dialogMapper';
import {DIALOG_CANCEL_ROLE} from '../../constants/dialogs';

// Backing out sits left, the action the window performs sits right — the order every dialog in the
// app follows. Sorting here rather than trusting each caller's array is what keeps them from
// drifting apart again; the sort is stable, so several actions keep the order they were listed in.
const cancelFirst = (buttons) =>
    [...buttons].sort(
        (a, b) => Number(b.role === DIALOG_CANCEL_ROLE) - Number(a.role === DIALOG_CANCEL_ROLE),
    );

const CustomDialog = (props) => {
    const {
        className,
        onClose,
        open,
        children,
        handelConfirm,
        whatDelete,
        warnings,
        linkToMeeting,
        setOpenConfirmDialog,
        title,
        buttons = [],
        ...other
    } = dialogMapper(props);
    return (
        <Dialog
            className={`custom-dialog ${className}`}
            onClose={() => onClose('')}
            open={open}
            {...other}
        >
            <DialogTitle className="custom-dialog-title">{title}</DialogTitle>
            <DialogContent className="custom-dialog-body">{children}</DialogContent>
            <DialogActions className="buttons-container app-button-container">
                {cancelFirst(buttons).map(({ label, handleClick, role, additionClassName = '', ...res }) => (
                    <Button
                        key={label}
                        variant="contained"
                        className={`dialog-button common-button ${additionClassName}`}
                        onClick={handleClick}
                        {...res}
                    >
                        {label}
                    </Button>
                ))}
            </DialogActions>
        </Dialog>
    );
};

Dialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.string]),
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    buttons: PropTypes.arrayOf(PropTypes.object),
};

export default CustomDialog;
